export enum TextSize {
  Small = '12-16',
  Medium = '13-18',
  Large = '14-20'
}
